import { useMemo } from 'react'

import { TFunction } from 'i18next'

import { OfferStatus } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'

export const useGuestInformationPayment = (
	offer: Offer,
	t: TFunction<'room-page', 'reservationTab'>
) => {
	return useMemo(() => {
		if (offer.IDs.wwtOfferId === undefined) {
			throw new Error('wwtOfferId is undefined')
		}

		// mock data
		if (offer.IDs.wwtOfferId.includes('-bbbb-bbbb-bbbb-bbbbbbbbbbbb')) {
			return t('paymentInformation.status.demo')
		}

		if (offer.IDs.status === OfferStatus.PAYMENT_PENDING) {
			return t('paymentInformation.status.pending')
		}

		if (offer.IDs.status === OfferStatus.PAYMENT_FAILED) {
			return t('paymentInformation.status.failed')
		}

		return t('paymentInformation.status.success')
	}, [offer.IDs.wwtOfferId, offer.IDs.status, t])
}
